import { Dispatch } from 'redux';
import { GET_POLICY_PDF_START, GET_POLICY_PDF_SUCCESS, GET_POLICY_PDF_FAILED } from './types';
import { ReduxStore } from '../payload-types';
import { ApiClient } from '../api.client';
import { LINKS } from '@trip-ux/constants';
import { interpolateTemplate } from '@trip-ux/common';

export const getPolicyPdf = (policyNumber: string, lang: string) => (
  dispatch: Dispatch,
  getState: () => ReduxStore,
  apiClient: ApiClient
): Promise<unknown> => {
  dispatch({ type: GET_POLICY_PDF_START, payload: policyNumber, lang });
  return apiClient(dispatch, getState)
    .get(interpolateTemplate(LINKS.POLICYPDF, { policyNumber }), {
      headers: { lang },
      responseType: 'arraybuffer'
    })
    .then(response => {
      const arrayBuffer = response.data;
      dispatch({
        type: GET_POLICY_PDF_SUCCESS,
        payload: new Blob([new Uint8Array(arrayBuffer)], { type: 'application/pdf' })
      });
    })
    .catch(error => {
      dispatch({
        type: GET_POLICY_PDF_FAILED,
        payload: error
      });
      throw error;
    });
};
